var jQuery        = require('jquery');
var _             = require('lodash');
var Rx            = require('ub_wrapped/rx');
var jsondiffpatch = require('jsondiffpatch');
var evtWhitelist  = require('./trigger-save-events-whitelist').default;

var rxUi = window.rxUi;

function init() {
  var _ignoreAttrs = function(element, data) {
    // TODO: this should be simplified/broken into named detector functions
    return (data.accessor.match(/geometry\.size\.height/) && element.type === 'lp-pom-text') ||
      (data.accessor.match(/content\.fields\.[0-9]+\./) && element.type === 'lp-pom-form') ||
      (data.accessor.match(/geometry\.label\.calculatedWidth/) && element.type === 'lp-pom-form') ||
      (data.accessor.match(/geometry\.size\.height/) && element.type === 'lp-pom-form') ||

      (data.accessor.match(/geometry\.offset/) &&
        element.type === 'lp-pom-button' && element.isFormButton() &&
        element.getParentElement().hasAutoButtonPlacement()) ||

      (data.accessor.match(/computations/)) ||
      data.accessor.match(/style\.background/);
  };

  var juiEvents = window.rxSwitchboard.subjects.jui_events; // RxJS event sources
  var continuousSwitch = new Rx.Subject();
  var continuousEventsStart = new Rx.Subject();
  var continuousEventsStop = new Rx.Subject();

  var immediateSwitch = continuousSwitch.map(function(val) {
    return ! val;
  });

  var attributeChangedEvents = Rx.Observable.merge(
    window.rxSwitchboard
      .subjects
      .element_set
      .map(function(ev) {
        return {
          element: window.editor.page.getElementById(ev.id),
          data: {
            value: ev.value,
            previous: ev.previous,
            initialjso: ev.initialjso,
            accessor: ev.accessor
          }
        };
      }),

      juiEvents
        .filter(function(ev) {
          return ev.type === 'attributeChanged';
        })
        .map(function(ev) {
          return {
            element: ev.source.element,
            data: ev.data
          };
        })
    )
    .filter(function(ev) {
      return ev.element && ev.element.type !== "lp-multi-select";
    });

  var transformEvents = Rx.Observable.merge(
    _.map(evtWhitelist, function (evnt) {
      return rxUi.eventBus.eventSinks[evnt];
    })
  ).filter(function (ev) {
    return ev.type === 'startDrag';
  });

  var mainContinuousEvents = Rx.Observable.merge(
    juiEvents.filter(function(ev) {
      return ev.type === 'mousedown' ||
        ev.type === 'blockHidden' ||
        (ev.type === 'actionPerformed' && ev.source && ev.source.name === 'mask');
    }),
    transformEvents
  );

  mainContinuousEvents.subscribe(function() {
    continuousSwitch.onNext(true);
    continuousEventsStart.onNext();
  });

  var reverseMainContinuousEvents = Rx.Observable.fromEvent(document, 'mouseup');

  reverseMainContinuousEvents.subscribe(function() {
    continuousEventsStop.onNext();
    continuousSwitch.onNext(false);
  });

  var undoExecuteEvents = window.rxSwitchboard.subjects.undo_manager_execute;
  undoExecuteEvents
    .subscribe(function() {
      continuousSwitch.onNext();
      continuousEventsStart.onNext(true);
    });

  var _transformToAccessors = function(object, accumulator) {
    // This flattens the keys to attribute accessor format separated by '.'
    function flatten(x, result, prefix) {
      if (_.isObject(x)) {
        _.each(x, function(v, k) {
          result = flatten(v, result, prefix ? prefix + '.' + k : k);
        });
      } else {
        result[prefix] = x;
      }
      return result;
    }

    if (! _.isObject(accumulator)) {
      accumulator = {};
    }

    return flatten(object, accumulator);
  };

  // Continuous events start/stop are markers for collecting attribute changes or model sets
  // They are not needed to generate synthetic event data and hence dont need to be threaded through
  var continuousEvents = continuousEventsStart
    .flatMap(function() {
      return attributeChangedEvents
        .scan(function(result, attrChangeEv) {
          var elmId = attrChangeEv.element.id;
          // Z-index is a calculated value and hence can be ignored during continuous action sequence.
          // However, we only to avoid it in continuous streams, not on one off events.
          if (attrChangeEv.data.accessor === 'geometry.zIndex') {
            return result;
          } else if (! _.has(result, elmId)) {
            // This applies for cases where a model set gets called first
            // This captures the initial unchanged state of the POM.
            // For example : update the url of a button and click on another element.
            // There is a mousedown and mouseup in quick successions with a model set called in between.
            // If we listen to attributeChange the models state has already changed by then.
            if(_.has(attrChangeEv.data, 'initialjso')) {
              result[elmId] = _.cloneDeep(attrChangeEv.data.initialjso);
            } else {
              // This applies when attributeChange gets fired in rapid successions multiple times.
              // For example : drag an element around. The event stream looks like
              // mousedown, attributeChange (first one), attributeChange, .... attributeChange, mouseup.
              // In this case, ignoring the very first unchanged model state is ok
              // because there will be more diffs in the consecutive drag ticks.
              // Unless, the user manages to drop the element precisely where he/she started from.
              result[elmId] = _.cloneDeep(attrChangeEv.element.model.jso);
            }
          }
          return result;
        }, {})
        .takeUntil(continuousEventsStop)
        .takeLast(1);
    })
    .map(function(initialStates) {
      // initialStates : This is an object containing the initialstates of
      // all the elements that have changed during the continuous events.
      // initialStates is not a sequence of observables.
      // The objective of this map is to transform initial states of elements:
      // {
      // lp-pom-box-7: initialjso of the box,
      // lp-pom-text-19: initialjso of the text in the box
      // }
      // to the diff of the current state of the elements
      // {
      // lp-pom-box-7: {'geometry.top': [previous value, current value], 'geometry.left': [previous value, current value]}
      // lp-pom-text-19: {'geometry.top': [previous value, current value], 'geometry.left': [previous value, current value]}
      // }
      // While we can possibly spit out the diff for each element as a stream
      // it might not be desired cause that will trigger the subscriber multiple times.
      // If we do emit a stream of the diffs, we would probably want to merge them back
      // before we attach the subscribers. This can be an improvement when we need individual diffs.

      //TODO: Is this mapping the element to the diff?
      //      Can we extract this so we can just see a stream of
      //      property change diffs given an initial state and current state?
      return _.reduce(initialStates, function(result, initialjso, id) {
        var currentElm = window.editor.page.getElementById(id);
        if (! currentElm) {
          // this will be null if id is a multi-select or the
          // element has been deleted by this point
          return result;
        }

        var currentjso = currentElm.model.jso;
        var flattenedInitialJso = _transformToAccessors(initialjso);
        var flattenedFinalJso = _transformToAccessors(currentjso);
        var diff = jsondiffpatch.diff(flattenedInitialJso, flattenedFinalJso);
        if (! _.isEmpty(diff)) {
          result[id] = {
            accessors: diff,
            element: currentElm
          };
        }
        return result;
      }, {});
    })
    .filter(function(delta) {
      return ! _.isEmpty(delta);
    });

  var juiParentChanges = juiEvents.filter(function(ev) {
    return ev.type === 'parentChanged';
  });

  var parentChangeEvents = continuousEventsStart
    .flatMap(function() {
      return juiParentChanges
        .scan(function(result0, ev) {
          var result = result0;
          if (! _.has(result, ev.data.id)) {
            result[ev.data.id] = {};
            result[ev.data.id].previous = ev.data.oldParentId;
          }
          result[ev.data.id].value = ev.data.containerId;
          return result;
        }, {})
        .takeUntil(continuousEventsStop)
        .takeLast(1);
    })
    .filter(function(initialResult) {
      return _.any(initialResult, function(obj) {
        return ! _.isEqual(obj.previous, obj.value);
      });
    });

  var immediateEvents = attributeChangedEvents
    .filter(function(ev) {
      return ! _.isEqual(ev.data.previous, ev.data.value);
    })
    .map(function(ev) {
      var delta = {},
        accessors = {};
      accessors[ev.data.accessor] = [ev.data.previous, ev.data.value];
      delta[ev.element.id] = {
        accessors: accessors,
        element: ev.element
      };
      return delta;
    });

  var modificationEventStream = Rx.Observable
    .merge(
      continuousEvents.pausable(continuousSwitch),
      immediateEvents.pausable(immediateSwitch)
    )
    .map(function(delta) {
      // From the delta get rid of all attributes which are calculated values or derived attributes.
      //TODO: the nesting obscures the intent of this.
      return _.reduce(delta, function(acc, data, elmId) {
        var clonedData = {
          element: data.element,
          accessors: _.reduce(data.accessors, function(res, values, accessor) {
            var obj = {};
            obj.accessor = accessor;
            obj.previous = _.first(values);
            obj.value = _.last(values);
            if(! _ignoreAttrs(data.element, obj)) {
              res[accessor] = values;
            }
            return res;
          }, {})
        };
        if(! _.isEmpty(clonedData.accessors)) {
          acc[elmId] = clonedData;
        }
        return acc;
      }, {});
    })
    .filter(function(delta) {
      return ! _.isEmpty(delta) && _.all(delta, function(data) {
        return ! _.isEmpty(data.accessors);
      });
    });

  var creationOrDeletionEventStream = Rx.Observable.merge(
    Rx.Observable.fromEvent(jQuery('[data-role="duplicateElementButton"]'), 'click'),

    juiEvents.filter(function(ev) {
      return _.contains([
        'elementInserted',
        'blockInserted',
        'blockRemoved'
      ], ev.type);
    })
    .filter(function(ev) {
      return ev.data.id !== 'dummy-section';
    }),

    juiEvents.filter(function(ev) {
      return _.contains([
        'elementRemoved'
      ], ev.type);
    })
    .filter(function(ev) {
      return ev.data.element && ev.data.element.id !== 'dummy-section';
    })
  );

  var pagePropertiesEvs = Rx.Observable.merge(
    rxUi.eventBus.eventSinks['ElementProperties,lp-pom-root'],
    rxUi.eventBus.eventSinks.PageGoalsPanel
  );

  var breakpointEvents = rxUi.eventBus.eventSinks.Editor
    .filter(function(ev) {
      return ev.type === 'setBreakpointEnabled';
    });

  var blockMovedEventStream = juiEvents.filter(function(ev) {
    return ev.type === 'blockMoved';
  });

  continuousSwitch.onNext(false);

  return {
    creationOrDeletionEventStream: creationOrDeletionEventStream,
    modificationEventStream: modificationEventStream,
    blockMovedEventStream: blockMovedEventStream,
    pausableParentChangeEvents: parentChangeEvents.pausable(continuousSwitch),
    pagePropertiesEvents: pagePropertiesEvs,
    breakpointEvents: breakpointEvents,
    transformEvents: transformEvents
  };
}

var POM_CHANGE_EVS;

module.exports = {
  getEventStream: function() {
    POM_CHANGE_EVS = POM_CHANGE_EVS || init();
    return POM_CHANGE_EVS;
  }
};



// WEBPACK FOOTER //
// ./src/events/pom-change-events.js